module.exports = __webpack_public_path__ + "assets/people/mayyaKim.e149ace87e6ae2c232fe9ea97b7b687f.png";